import React from 'react'
import { terms } from '../../../constants/activity-constants'
import './termsSection.scss'

const TermsSection = props => {
  const { mobile } = props

  return (
    <div className="f-termsSection-container">
      <div
        id="terminos-y-condiciones"
        className="f-termsSection-container__ancla"
      />
      <div className="f-termsSection-container__wrapper">
        <span className="f-titulo-terms">Términos y condiciones</span>
        <div className="f-termsSection-container__wrapper__content">
          <ul>
            {terms().map((item, index) => {
              return (
                <li>
                  <span>{index + 1}.</span> {item}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default TermsSection
